import React from "react";
import { StandardTooltip } from "../../../../shared/StandardTooltip/StandardTooltip";
import { initialsOf } from "../../_config/okrPlansCoachFormat";

// ═══════════════════════════════════════════════════════════════════════════
// One company on the dashboard — today's Plans `sme-card` (BE 2.7, CD15):
// locked (greyed, lock icon, tooltip) only when `has_okr_plans` is false.
// ═══════════════════════════════════════════════════════════════════════════

const BLOCKED_TIP =
  "Plans open here once this company's Quarterly OKRs are locked";

const CompanyCard = ({ company, onOpen }) => {
  const open = !!company.has_okr_plans;
  const card = (
    <div
      className={`sme-card opc-company-card ${open ? "cursor-pointer" : "is-blocked"}`}
      role={open ? "button" : undefined}
      tabIndex={open ? 0 : undefined}
      aria-disabled={!open}
      onClick={open ? onOpen : undefined}
      onKeyDown={(e) => open && e.key === "Enter" && onOpen()}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div className="short-name-badge text-center d-flex flex-column justify-content-center align-items-center">
            {company.initials || initialsOf(company.name)}
          </div>
          <span className="fw-bold ms-2 dark-grey">{company.name}</span>
        </div>
        {open ? (
          <img
            src="/assets/images/right-arrow.svg"
            className="cursor-pointer hover-effect"
            alt=""
          />
        ) : (
          <img
            src="/assets/images/lock-light-icon.svg"
            className="opc-lock"
            alt=""
          />
        )}
      </div>
      <div className="d-flex align-items-center justify-content-between mt-4">
        <div className="d-flex flex-column">
          <span className="fw-bold light-text detail-text">
            {open ? company.plans : "-"}
          </span>
          <span className="sme-detail light-text mt-2">Total OKRs</span>
        </div>
        <div className="d-flex flex-column">
          <span className="fw-bold light-text detail-text">
            {company.members}
          </span>
          <span className="sme-detail light-text mt-2">Team Members</span>
        </div>
        {open ? (
          <div className="d-flex flex-column">
            <span className="fw-bold light-text detail-text">
              {company.checkins_due || "No"}
            </span>
            <span className="sme-detail light-text mt-2">Check-in due</span>
          </div>
        ) : null}
      </div>
    </div>
  );
  return (
    <div className="col-md-4">
      {open ? (
        card
      ) : (
        <StandardTooltip tooltTipContent={BLOCKED_TIP}>{card}</StandardTooltip>
      )}
    </div>
  );
};

export default CompanyCard;
